import { ChangeDetectionStrategy, Component, forwardRef, input, output, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputSize } from '../../../enum/input-size.enum';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lib-textarea-input',
  templateUrl: './textarea-input.component.html',
  styleUrls: ['./textarea-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaInputComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
})
export class TextareaInputComponent implements ControlValueAccessor {
  placeholder = input<string>('');
  controlId = input<string | null>(null);
  error = input<boolean>(false);
  inputSize = input<InputSize>(InputSize.large);
  showClearButton = input<boolean | null | undefined>();
  rows = input<number>(3);
  valueChange = output<string | null>();

  protected readonly InputSize = InputSize;

  public value = signal<string | null>(null);
  public disabled = signal(false);

  public writeValue(value: string | null): void {
    this.value.set(value);
  }

  public registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public handleInput(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.value.set(inputValue);
    this.valueChange.emit(inputValue);
    this.onChange(inputValue);
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  public clearClicked(): void {
    this.value.set(null);
    this.valueChange.emit(null);
    this.onChange(null);
  }

  private onChange: (value: string | null) => void = () => {
    // default onChange
  };
  private onTouched: () => void = () => {
    // default onTouched
  };
}
